import { useModal } from "../contexts";
import { BLOCK_ICON_MAP, BLOCK_NAME_MAP } from "../utils";
import ProLabel from "./ProLabel";
import PayWallModalPro from "./PayWallModalPro";
import BetaLabel from "./BetaLabel";
import WorkflowModalHubspotObjects from "./WorkflowModalHubspotObjects";

interface BaseProps {
  title: string;
  subtitle: string;
  onSelection: (blockType: string, primaryObject: string) => void;
  beta?: boolean;
}

interface NonProProps extends BaseProps {
  pro?: false;
}

interface ProProps extends BaseProps {
  pro: true;
  hasProFeature: boolean;
}


type Props = NonProProps | ProProps;

function WorkflowSelectHubspotButton(props: Props) {
  const { openModal } = useModal();

  function createBlock(selectedObjectId: string) {
    if (!selectedObjectId)
      return;

    if (props.pro && !props.hasProFeature)
      openModal(<PayWallModalPro />);
    else
      props.onSelection("HUBSPOT", selectedObjectId);
  }

  return (
    <button className="flex flex-shrink-0 items-center border-2 border-gray-200 hover:border-blue rounded cursor-pointer p-4" onClick={() => openModal(<WorkflowModalHubspotObjects onSelect={createBlock} />)}>
      <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center"><img className="w-10 h-10" src={BLOCK_ICON_MAP["HUBSPOT"]} alt={BLOCK_NAME_MAP["HUBSPOT"]} /></div>
      <div className="flex flex-col items-start text-left ml-4">
        <div className="font-gilroy font-semibold text-base text-gray-600">
          {props.title}
        </div>
        <div className="font-gilroy font-semibold text-xs text-gray-400">
          {props.subtitle}
        </div>
      </div>
      {props.pro && <ProLabel />}
      {props.beta && <BetaLabel />}
    </button>
  );
}

export default WorkflowSelectHubspotButton;
